"use client";

import { createContext, useContext } from "react";

/**
 * The `crhPageSettings` fields support-hub client components actually read via
 * `useCrhPageSettings()`. Fetched (with many more fields besides) once in the
 * support-hub `layout.tsx` and threaded down through this context rather than
 * every consumer fetching its own copy.
 */
export type CrhPageSettingsContextValue = {
  interestGroupsLabel: string | null;
  searchCancelSearchButtonLabel: string | null;
  searchLoadingMessageLabel: string | null;
  searchLoadingErrorLabel: string | null;
  searchNoResultsLabel: string | null;
  searchSearchResultsTitleLabel: string | null;
  supportBannerHeadline: string;
  supportBannerBody: string;
  supportBannerCtaLabel: string;
  fullAnswerButtonLabel: string;
};

const CrhPageSettingsContext =
  createContext<CrhPageSettingsContextValue | null>(null);

export const CrhPageSettingsContextProvider = ({
  children,
  value,
}: {
  value: CrhPageSettingsContextValue;
  children: React.ReactNode;
}) => (
  <CrhPageSettingsContext.Provider value={value}>
    {children}
  </CrhPageSettingsContext.Provider>
);

export function useCrhPageSettings() {
  const settings = useContext(CrhPageSettingsContext);

  if (!settings) {
    throw new Error("CrhPageSettingsContext used outside of Provider");
  }

  return settings;
}
